import { v4 as uuidv4 } from "uuid";
import { formatDistanceToNow, isToday, isYesterday } from "date-fns";
export class DetailedNotificationModel {
    constructor() {
        this.id = uuidv4();
        this.typeId = "";
        this.isSeen = false;
        this.componentName = "";
        this.isComplete = false;
    }
    formatTime() {
        const parsedDate = new Date(this.requestedTime);
        if (isToday(parsedDate)) {
            return formatDistanceToNow(parsedDate, { addSuffix: true, includeSeconds: true });
        }
        if (isYesterday(parsedDate)) {
            return "Yesterday";
        }
        return formatDistanceToNow(parsedDate, { addSuffix: true });
    }
    formattedTime() {
        const timeDifferenceMs = new Date().getTime() - new Date(this.requestedTime).getTime();
        // Seconds value  for each label
        const units = [
            { value: 31536000, label: "y" },
            { value: 2592000, label: "m" },
            { value: 604800, label: "w" },
            { value: 86400, label: "d" },
            { value: 3600, label: "h" },
            { value: 60, label: "m" },
            { value: 1, label: "s" },
        ];
        for (const unit of units) {
            const difference = Math.round(timeDifferenceMs / (1000 * unit.value));
            if (difference >= 1) {
                return difference + " " + unit.label;
            }
        }
        return "";
    }
}
export default class DetailedNotification extends DetailedNotificationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
